import React from "react";
import { Locale } from "@linkfluence/models/locale";
import Title from "@radarly/components/panels/card-edition/sidebar/title";
import { Card } from "@radarly/models/cards";
import { editTitleOnCard } from "@radarly/models/cards/editor";

export interface SharedPanelsCardEditionSidebarTitleProps {
  card: Card;
  setCard: (card: Card) => void;
  locale: Locale;
}

export default function SharedPanelsCardEditionSidebarTitle({
  card,
  setCard,
  locale,
}: SharedPanelsCardEditionSidebarTitleProps) {
  return (
    <>
      <Title
        title={card.title}
        setTitle={(title) => setCard(editTitleOnCard(card, title))}
        locale={locale}
      />
    </>
  );
}
